import { render, staticRenderFns } from "./PageUserPassReset.vue?vue&type=template&id=700a8492&scoped=true"
import script from "./PageUserPassReset.vue?vue&type=script&lang=js"
export * from "./PageUserPassReset.vue?vue&type=script&lang=js"
import style0 from "./PageUserPassReset.vue?vue&type=style&index=0&id=700a8492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a8492",
  null
  
)

export default component.exports